// extracted by mini-css-extract-plugin
module.exports = {"SEmbedConsentPlaceholder":"EmbedConsentPlaceholder_SEmbedConsentPlaceholder__VHgcm","SConsentNeededTrigger":"EmbedConsentPlaceholder_SConsentNeededTrigger__Kk2eQ"};